import { MouseEventHandler } from 'react'
import './CameraConfirmationPage.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateLeft, faXmark } from '@fortawesome/free-solid-svg-icons'
import { useOrientation } from './useOrientation'

interface CameraConfirmationPageProps {
    photo: any
    confirmHandler: MouseEventHandler<HTMLButtonElement>
    revertHandler: MouseEventHandler<HTMLButtonElement>
    closeCameraHandler: MouseEventHandler<HTMLButtonElement>
    isiOS?: boolean
}

/* istanbul ignore next */
const CameraConfirmationPage = (props: CameraConfirmationPageProps) => {
    const { photo, confirmHandler, revertHandler, closeCameraHandler, isiOS } = props

    const orientation = useOrientation()
    const isLandscape = orientation === 'landscape'
    const confirmText = isLandscape ? 'Conferma foto' : 'Conferma'

    const closeConfirmationHandler = (ev: any) => {
        revertHandler(ev)
        closeCameraHandler(ev)
    }
    const iosClassName = isiOS ? 'ios-device' : ''

    return (

        <div className={`camera-capture-container camera-confirm-page ${orientation} ${iosClassName}`}>
            {
                photo &&
                <div className="video-container">

                    <img
                        className='confirm-photo-img'
                        src={photo} alt="Captured"
                    />
                </div>
            }
            
            <button
                className={`close-camera cmd-btn`}
                onClick={closeConfirmationHandler}>
                <FontAwesomeIcon
                    icon={faXmark} />
            </button>

            <div className='right-item-container'>
                <button
                    className="procedure-done-btn"
                    onClick={confirmHandler}>{confirmText}</button>
            </div>

            <div className='left-item-container'>
                <button className="left-label-item"
                    onClick={revertHandler}>
                    <FontAwesomeIcon icon={faRotateLeft} />
                    Scatta di nuovo
                </button>
            </div>

        </div >
    )
}

export default CameraConfirmationPage